export default __webpack_public_path__ + "static/media/summer.20784f05.jpg";